
















































































































































































































































import {
    CREATE_PAYMENT_INTENT,
    SET_ORDER_STATUS,
    UPDATE_ORDER,
} from "@/queries/customer/mutation.graphql";
import {
    GET_CLIENT_MENU,
    GET_ORDER_DISH,
    GET_ORDER_STATUS,
} from "@/queries/customer/query.graphql";
import Vue from "vue";
import OrderOverview from "./OrderOverview.vue";
import AddCreditCardModal from "./AddCreditCardModal.vue";
import { stripe } from "@/services/stripe/stripe";
import { bus } from "@/utils/event-emitter";
const PAYMENT_METHODS = {
    cash: "ORDERED_NOT_PAID",
    creditCard: "ORDERED_PAID_ONLINE",
    paymentBtn: "ORDERED_PAID_ONLINE",
    applePay: "",
    googlePay: "",
    paypal: "",
};

export default Vue.extend({
    components: {
        OrderOverview,
        AddCreditCardModal,
    },
    data() {
        return {
            orders: [],
            height: null,
            isOpen: false,
            isMobile: null,
            description: "",
            hasPaymentButton: false,
            isApple: false,
            paymentMethod: "cash",
            isLoading: false,
            addCreditCard: false,
            confirmCash: false,
            paymentRequest: null,
            user: null,
        };
    },
    apollo: {
        orders: {
            query: GET_ORDER_DISH,
            update: (data: any) => data.OrderDish,
        },
        user: {
            query: GET_CLIENT_MENU,
            variables() {
                return {
                    id: this.$route.params.menuId,
                };
            },
            update: (data: any) => {
                return data.Menu[0].User;
            },
        },
    },
    computed: {
        itemsCount(): number {
            return this.orders.length || 0;
        },
        totalPrice() {
            console.log(this.$store.getters["customerModule/totalPrice"]);

            return this.$store.getters["customerModule/totalPrice"];
        },
    },
    methods: {
        async setOrder(cache?: boolean) {
            if (cache) {
                this.isLoading = true;
            }
            await this.$apollo.mutate({
                mutation: UPDATE_ORDER,
                variables: {
                    notes: this.description,
                },
            });

            this.$apollo
                .mutate({
                    mutation: SET_ORDER_STATUS,
                    variables: {
                        orderId: this.$store.getters["authModule/orderId"],
                        status: PAYMENT_METHODS[this.paymentMethod],
                    },
                    update: (cache, { data: { setOrderStatus } }) => {
                        if (setOrderStatus) {
                            const data: any = cache.readQuery({
                                query: GET_ORDER_STATUS,
                                variables: {
                                    id: this.$store.getters[
                                        "authModule/orderId"
                                    ],
                                },
                            });
                            data.Order[0].status = setOrderStatus.Order.status;
                            data.Order[0].number = setOrderStatus.Order.number;
                            data.Order[0].cache = setOrderStatus.Order.cache;
                            cache.writeQuery({
                                query: GET_ORDER_STATUS,
                                data,
                            });
                        }
                    },
                })
                .then((data: any) => {
                    this.isLoading = false;
                    this.addCreditCard = false;
                    this.$router.push("complete");
                })
                .catch((error: any) => (this.isLoading = false));
        },
        async requestPaymentBtn() {
            const btnElm = this.$refs.paymentBtn;
            console.log(btnElm);
            console.log(this.$store.getters["customerModule/totalPrice"]);
            if (!stripe) return;
            this.paymentRequest = stripe.paymentRequest({
                country: "AU",
                currency: "aud",
                total: {
                    label: "Order",
                    amount: this.totalPrice,
                },
            });
            // const elements = stripe.elements();
            // const prButton = elements.create("paymentRequestButton", {
            //   paymentRequest: this.paymentRequest,
            //   style: {
            //     paymentRequestButton: {},
            //   },
            //   classes: {
            //     base: "border-radius-3",
            //   },
            // });
            const result = await this.paymentRequest.canMakePayment();
            if (result) {
                this.hasPaymentButton = true;
                this.isApple = result.applePay;
                // prButton.mount("#payment-request-btn");
            } else {
                // document.getElementById("payment-request-btn").style.display = "none";
                this.hasPaymentButton = false;
            }
            this.paymentRequest.on("paymentmethod", async (ev) => {
                // Confirm the PaymentIntent without handling potential next actions (yet).
                const {
                    data: { generateStripePaymentIntent },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: CREATE_PAYMENT_INTENT,
                });
                const clientSecret = generateStripePaymentIntent.clientSecret;
                const {
                    paymentIntent,
                    error: confirmError,
                } = await stripe.confirmCardPayment(
                    clientSecret,
                    { payment_method: ev.paymentMethod.id },
                    { handleActions: false }
                );

                if (confirmError) {
                    // Report to the browser that the payment failed, prompting it to
                    // re-show the payment interface, or show an error message and close
                    // the payment interface.
                    this.$toastr.e(confirmError.message);
                    ev.complete("fail");
                } else {
                    // Report to the browser that the confirmation was successful, prompting
                    // it to close the browser payment method collection interface.
                    // alert("before success number one");
                    // this.setOrder().then(() => {
                    ev.complete("success");
                    // alert("success number one");
                    // });
                    // Check if the PaymentIntent requires any actions and if so let Stripe.js
                    // handle the flow. If using an API version older than "2019-02-11" instead
                    // instead check for: `paymentIntent.status === "requires_source_action"`.
                    if (paymentIntent.status === "requires_action") {
                        // Let Stripe.js handle the rest of the payment flow.
                        const { error } = await stripe.confirmCardPayment(
                            clientSecret
                        );
                        if (error) {
                            this.$toastr.e(error.message);
                            // The payment failed -- ask your customer for a new payment method.
                        } else {
                            // The payment has succeeded.
                            this.setOrder().then(() => {
                                ev.complete("success");
                            });
                        }
                    } else {
                        // alert("before success number three");
                        // The payment has succeeded.
                        this.setOrder().then(() => {
                            ev.complete("success");
                        });
                    }
                }
            });
        },
        save(e) {
            this.description = e;
        },
        test(el: HTMLElement) {
            this.height = el.scrollHeight;
        },
        checkSize() {
            if (window.innerWidth > 992) {
                this.isMobile = false;
                return;
            }
            this.isMobile = true;
        },
    },
    watch: {
        totalPrice(newVal) {
            if (this.paymentRequest) {
                this.paymentRequest.update({
                    total: {
                        label: "Order",
                        amount: this.totalPrice,
                    },
                });
            }
        },
        isOpen(newVal, oldVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.requestPaymentBtn();
                });
            }
            if (newVal && this.isMobile) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        },
        orders: {
            handler(newVal) {
                if (this.orders.length === 0) {
                    if (this.isOpen) {
                        this.isOpen = false;
                    }
                }
            },
            deep: true,
        },
    },
    mounted() {
        bus.$on("creditCardSuccess", () => {
            this.paymentMethod = "creditCard";
            this.setOrder();
        });
        this.checkSize();
    },
    created() {
        window.addEventListener("resize", this.checkSize);
    },
    destroyed() {
        window.removeEventListener("resize", this.checkSize);
        document.body.style.overflow = "auto";
    },
});
